import Conversations from '@twilio/conversations'

export default class ChatService {
  constructor(token) {
    this.client = null
    this.token = token

    this.conversationSid = null
    this.conversationClient = null
  }

  async connect() {
    this.client = await Conversations.create(this.token)
  }

  async connectToConversationBySid(sid) {
    this.conversationClient = await this.client.getConversationBySid(sid)
    this.conversationSid = this.conversationClient.sid
  }

  async addListenersToConversation(name, callback) {
    await this.conversationClient.on(name, (parameter) => callback(parameter))
  }

  async joinConversation() {
    await this.conversationClient.join()
  }

  async sendMessage(message) {
    await this.conversationClient.sendMessage(message)
  }
}
